import Service from "./../../../../utils/api/service";
import TableLoading from "./../../../../components/share/table-loading";
import NoItem from "./../../../../components/share/table-no-item";
import { mapState } from "vuex";
import Helper from "../../../../utils/global/func";

export default {
  name: "ListRole",
  data() {
    return {
      isFetching: true,
      isDeleting: false,
      isNoData: false,
      search: {
        status: "",
      },
      display: {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
        },
      },
      data: {
        totalItems: 10,
        page: 1,
        pageSize: 10,
        totalNumPage: 1,
        roles: [],
        roleList: [],
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
    };
  },
  components: {
    TableLoading,
    NoItem,
  },
  created() {
    this.setParams();
    this.getAllUser();
  },
  mounted() {},
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getAllUser();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  methods: {
    setParams() {
      const query = this.$route.query;
      this.search = this.$helper.setParams(this.search, query);
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getAllUser() {
      this.isFetching = true;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        ...query,
      });
      delete setQuery.branchIds;
      let params = this.$helper.queryParam(setQuery);

      Service.getAllRole(params).then((response) => {
        this.isFetching = false;

        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getAllUser();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.roleList = [];
            this.$toasted.show(response?.message);
          } else {
            this.$toasted.show(response?.message);
            this.errorMessage = response?.message || "No Data";
            this.data.roleList = [];
            this.isNoData = true;
            this.resetPagination();
          }
        } else {
          if (response.data && response.data.length > 0) {
            this.isNoData = false;
            this.data.roleList = response?.data;
            this.data.pagination = response?.meta
              ? Helper.calculatePagination(response?.meta)
              : "";
          } else {
            this.data.roleList = [];
            this.isNoData = true;
            this.resetPagination();
          }
        }
      });
    },

    resetPagination() {
      this.data.pagination = {
        limit: 10,
        page: 1,
        total: 0,
        totalPage: 0,
      };
    },

    async searchStatus() {
      const query = Object.assign({}, this.$route.query);
      query.status = this.search.status;
      await this.$router.push({ query });
    },

    deleteRole() {
      this.isDeleting = true;
      let roleId = this.data.roleList[this.display.modal.delete.index].id;
      Service.deleteRole(roleId).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.deleteRole();
              }
            });
          } else {
            this.isDeleting = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isDeleting = false;
          this.data.roleList.splice(this.display.modal.delete.index, 1);
          this.$toasted.show("Role has been deleted.");
          this.closeModal();
        }
      });
    },

    popupModalDelete(index) {
      this.display.modal.delete.index = index;
      this.display.modal.delete.show = true;
    },

    closeModal() {
      this.display = {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
        },
      };
    },

    modalDetail() {
      this.display.modal.detail = true;
    },
  },
};
